import radar from '@ro-images/radar-icon.png';
import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import { Icon as OlIcon, Style } from 'ol/style.js';
import { transform } from 'ol/proj.js';

const radars = [
  {
    name: 'Legionowo',
    long_name: 'Radar Meteorologiczny Legionowo',
    coordinates: {
      lon: 20.96091111,
      lat: 52.40521944
    }
  },
  {
    name: 'Rzeszów',
    long_name: 'Radar Meteorologiczny Rzeszów',
    coordinates: {
      lon: 22.03669167,
      lat: 50.11383056
    }
  },
  {
    name: 'Brzuchania',
    long_name: 'Radar Meteorologiczny Brzuchania',
    coordinates: {
      lon: 20.08343056,
      lat: 50.39420278
    }
  },
  {
    name: 'Ramża',
    long_name: 'Radar Meteorologiczny Ramża',
    coordinates: {
      lon: 18.72496111,
      lat: 50.151275
    }
  },
  {
    name: 'Pastewnik',
    long_name: 'Radar Meteorologiczny Pastewnik',
    coordinates: {
      lon: 16.03949167,
      lat: 50.89244722
    }
  },
  {
    name: 'Poznań',
    long_name: 'Radar Meteorologiczny Poznań',
    coordinates: {
      lon: 16.79705556,
      lat: 52.41325833
    }
  },
  {
    name: 'Świdwin',
    long_name: 'Radar Meteorologiczny Świdwin',
    coordinates: {
      lon: 15.83804722,
      lat: 53.79451389
    }
  },
  {
    name: 'Gdańsk',
    long_name: 'Radar Meteorologiczny Gdańsk',
    coordinates: {
      lon: 18.45638889,
      lat: 54.38421389
    }
  }
];

export const setRadarMarkers = map => {
  const radarMarkers = [];

  radars.map(function(polradPoint, i) {
    return radarMarkers.push(
      new Feature({
        type: 'icon',
        geometry: new Point(
          transform([polradPoint.coordinates.lon, polradPoint.coordinates.lat], 'EPSG:4326', 'EPSG:3857')
        )
      })
    );
  });

  const vectorLayer = new VectorLayer({
    renderMode: 'image',
    index: 0,
    source: new VectorSource({
      features: radarMarkers,
      useSpatialIndex: false
    }),
    style: new Style({
      image: new OlIcon({
        src: radar
      })
    })
  });
  map.addLayer(vectorLayer);
};
